import { CONTENT } from "@/content";

type Props = {
  onHome: () => void;
  onWhats: () => void;
};

export function P5({ onHome, onWhats }: Props) {
  const p = CONTENT.p5;
  const parts = p.title.split("! ");
  return (
    <div className="fx fx-thanks page-enter">
      <main className="fx-main fx-main-center">
        <div className="fx-ty">
          <span className="fx-check fx-check-lg">
            <span className="fx-check-mark">
              <svg className="fx-check-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <path d="M5 12.5l4.2 4.2L19 7" />
              </svg>
            </span>
          </span>
          <h1 className="fx-ty-title">
            {parts.length > 1 ? (
              <>
                <span className="fx-ty-line1">{parts[0]}!</span>
                {parts[1]}
              </>
            ) : (
              p.title
            )}
          </h1>
          <p className="fx-ty-sub">{p.subtitle}</p>
          <div className="fx-ty-card">
            <p className="fx-ty-confirm">{p.confirm}</p>
            <p className="fx-ty-reinforce">{p.reinforce}</p>
            <p className="fx-ty-next">{p.next}</p>
          </div>
          <div className="fx-ty-trust">
            {p.trust.map((t, i) => (
              <span key={i} className="fx-ty-trust-i">{t}</span>
            ))}
          </div>
          <div className="fx-ty-actions">
            <button className="btn btn-whats btn-lg" onClick={onWhats}>{p.ctaWhats}</button>
            <button className="btn btn-ghost btn-lg" onClick={onHome}>{p.ctaBack}</button>
          </div>
          <p className="fx-ty-final">{p.final}</p>
        </div>
      </main>
    </div>
  );
}
